export enum ProgramType {
    System = 'System',
    Custom = 'Custom'
}
